import React from 'react';
import { Box } from '@mos-cat/ds';

import { useDataContext } from '../../context/useDataContext';
import { CheckDataStatus } from '../../@types/checkData';
import OutageInfoContent from './OutageInfoContent';

// typograf-enable
export default function OutageInfo() {
  const { checkDataStatus } = useDataContext();

  const isOutageContentVisible = checkDataStatus === CheckDataStatus.Success;

  return (
    <Box aria-live="polite" mt={isOutageContentVisible ? 'sp-16' : undefined}>
      {isOutageContentVisible && <OutageInfoContent />}
    </Box>
  );
}
